import { render } from "./SingleInputor.vue?vue&type=template&id=1a9bc421&scoped=true"
import script from "./SingleInputor.vue?vue&type=script&lang=js"
export * from "./SingleInputor.vue?vue&type=script&lang=js"

import "./SingleInputor.vue?vue&type=style&index=0&id=1a9bc421&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9bc421"]])

export default __exports__